import React, { FC } from 'react';
import * as classes from './RatesListItem.module.scss';
import cn from 'classnames';
import { IRates } from '../../../../../../interfaces/professional/Professional';

interface Props extends IRates {
  itemDescriptionClassName?: string;
}

const RatesListItem: FC<Props> = ({ description, price, currency, itemDescriptionClassName }) => {
  return (
    <li className={classes.wrapper}>
      <div className={'row'}>
        <div className={cn('col-9', itemDescriptionClassName)}>{description}</div>
        <div className={cn('col-3', classes.price)}>{`${price} ${currency}`}</div>
      </div>
    </li>
  );
};

export default RatesListItem;
